import { render, staticRenderFns } from "./storeOrderCartReturn.vue?vue&type=template&id=6f595f9a&scoped=true"
import script from "./storeOrderCartReturn.vue?vue&type=script&lang=js"
export * from "./storeOrderCartReturn.vue?vue&type=script&lang=js"
import style0 from "./storeOrderCartReturn.vue?vue&type=style&index=0&id=6f595f9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f595f9a",
  null
  
)

export default component.exports